import styles from './style.module.scss';
import { Col, Row, Spin, Typography } from 'antd';
import useFootfall from '../useFootfall';
import PrintFilterText from '../../printFiiterText';
import FootfallPrint from '../../footfall/print/index';
import SalesPrint from '../../invoicesSalesVillage/print';
import InvoicesCompareFootfallSalesPrint from '../../invoicesCompareFootfallSales/print';
import InvoicesConversionRateVillagePrint from '../../invoicesConversionRateVillage/print';
import InvoicesAtvVillagePrint from '../../invoicesAtvVillage/print';
import InvoicesUptVillagePrint from '../../invoicesUptVillage/print';
import InvoicesPiecesPrint from '../../invoicesPieces/print';
import InvoicesTicketsPrint from '../../invoicesTickets/print';
import KpiPrint from '../../kpi/print';
import KpiWeekdaysHolidaysPrint from '../../kpiWeekdaysHolidays/print';
import ConsumiNetSalesPrint from '../../consumiNetSales/print';
import InvoicesCategoryPiecesPrint from '../../invoicesCategoryPieces/print';
import InvoicesCategoryTicketsPrint from '../../invoicesCategoryTickets/print';
import StoreVsVillagePrint from '../../storeVsVillage/print';
import FootfallStoreVsVillagePrint from '../../footfallStoreVsVillage/print';
import InvoicesSalesCompetitorsPrint from '../../invoicesSalesCompetitors/print';
import InvoicesSalesTrendsPrint from '../../invoicesSalesTrends/print';
import SalesTrackingsGenderAgePrint from '../../salesTrackingsGenderAge/print';
import SalesTrackingsGenderBrandPrint from '../../salesTrackingsGenderBrand/print';

const Print = ({}) => {
  const { title, searchParams, loading, filters, data } = useFootfall(true);
  localStorage.setItem('auth_token', searchParams.get('token'));

  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        {byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <br />
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
            <br />
            <Row>
              <Col span={24}>
                <FootfallPrint
                  isAllReports
                  allReportsData={data.footfalls}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <SalesPrint
                  isAllReports
                  allReportsData={data.sales}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesCompareFootfallSalesPrint
                  isAllReports
                  allReportsData={data.footfall_sales}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesConversionRateVillagePrint
                  isAllReports
                  allReportsData={data.conversion_rate}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesAtvVillagePrint
                  isAllReports
                  allReportsData={data.atv}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesUptVillagePrint
                  isAllReports
                  allReportsData={data.upt}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesPiecesPrint
                  isAllReports
                  allReportsData={data.pieces}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesTicketsPrint
                  isAllReports
                  allReportsData={data.tickets}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <KpiPrint
                  isAllReports
                  allReportsData={data.kpi}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <KpiWeekdaysHolidaysPrint
                  isAllReports
                  allReportsData={data.kpi_weekdays_holidays}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <ConsumiNetSalesPrint
                  isAllReports
                  allReportsData={data.consumi_net_sales}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesCategoryPiecesPrint
                  isAllReports
                  allReportsData={data.consumi_pieces}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesCategoryTicketsPrint
                  isAllReports
                  allReportsData={data.consumi_tikets}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <StoreVsVillagePrint
                  isAllReports
                  allReportsData={data.store_vs_village}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <FootfallStoreVsVillagePrint
                  isAllReports
                  allReportsData={data.footfall_store_vs_village}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesSalesCompetitorsPrint
                  isAllReports
                  allReportsData={data.sales_competitors}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <InvoicesSalesTrendsPrint
                  isAllReports
                  allReportsData={data.brand_cross_village}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <SalesTrackingsGenderAgePrint
                  isAllReports
                  allReportsData={data.gender_age}
                  allReports={true}
                />
              </Col>
              <Col span={24}>
                <SalesTrackingsGenderBrandPrint
                  isAllReports
                  allReportsData={data.gender_brand}
                  allReports={true}
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default Print;
